import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Panel } from 'react-bootstrap'
import autobind from 'autobind-decorator'
import GuestInfoInput from '../components/guestInfoInput'
import * as _ from 'lodash'
import GuestEntryCommonInputs from '../components/guestEntryCommonInputs'

@autobind
export default class GuestInfoForm extends Component {
  static propTypes = {
    totalGuests: PropTypes.number,
    dispatch: PropTypes.func,
    authenticated: PropTypes.bool
  }
  render() {
    let {
      commonGuestFields,
      selectedRooms,
      guestDetails,
      rooms,
      authenticated,
      dispatch
    } = this.props
    let payingGuestDetails = _.take(guestDetails, 1)
    let payingGuestDetailsHtml = _.flatMap(
      payingGuestDetails,
      (guestField, guestIndex) => {
        return (
          <GuestInfoInput
            selectedRooms={selectedRooms}
            guestIndex={guestIndex}
            fields={guestField}
            authenticated={authenticated}
            totalGuests={1}
            rooms={rooms}
            dispatch={dispatch}
            payingGuest
          />
        )
      }
    )

    let otherGuestsDetails = _.takeRight(guestDetails, guestDetails.length - 1)
    let otherGuestsHtml = _.flatMap(
      otherGuestsDetails,
      (guestField, guestIndex) => {
        return (
          <GuestInfoInput
            selectedRooms={selectedRooms}
            guestIndex={guestIndex >= 0 ? guestIndex + 1 : null}
            fields={guestField}
            authenticated={authenticated}
            totalGuests={1}
            rooms={rooms}
            dispatch={dispatch}
            payingGuest={false}
          />
        )
      }
    )
    let commonInputs = (
      <GuestEntryCommonInputs
        fields={commonGuestFields}
        authenticated={authenticated}
      />
    )
    return (
      <div>
        <Panel header='Paying Participant'>
          {payingGuestDetailsHtml}
          {commonInputs}
        </Panel>
        {otherGuestsDetails && otherGuestsDetails.length > 0 ? (
          <Panel header='Other Participants'>{otherGuestsHtml}</Panel>
        ) : (
          ''
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/guestInfoForm.js